import React, { useState } from 'react'
import { Col, Container, Form, FormGroup, Label, Input } from 'reactstrap';
import CustomInput from './CustomInput';
import { Eye, EyeOff, Mail } from 'assets';
import CustomButton from 'components/CustomButton';
import { useNavigate } from 'react-router-dom';
import { API_POST_MAMBOO } from 'services';
import useLoginStore from 'hooks/useLoginStore';

const Register = () => {
  const [registerForm, setRegisterForm] = useState({
    publisher: "",
    email: "",
    password: "",
    repeatPassword: "",
    invitationCode: ""
  })

  const [isPasswordShow, setIsPasswordShow] = useState({
    password: false,
    repeatPassword: false
  })

  const [inputError, setInputError] = useState({
    publisher: [],
    email: [],
    password: [],
    repeatPassword: [],
    code: ""
  })
  const { setProfile, fetchServerProfile } = useLoginStore()

  const errorMessage = {
    publisher: ["Nama tidak boleh mengandung symbol seperti, { @ *.."],
    email: ["Format Email Tidak Sesuai"],
    password: ["Kata sandi terlalu pendek, minimal 8 karakter", "Harus berisi setidaknya satu huruf kapital", "Harus berisi setidaknya satu angka", "Setidaknya harus mengandung karakter khusus"],
    repeatPassword: ["Kata sandi tidak sama"]
  }

  const navigate = useNavigate()

  const handleBackToLogin = () => {
    navigate("/auth/login")
  }

  const passwordIconAction = (name) => {
    setIsPasswordShow({ ...isPasswordShow, [name]: !isPasswordShow[name] })
  }

  const onChange = (e) => {
    const { name, value } = e.target
    let re;
    let isValid;

    switch (name) {
      case "publisher":
        re = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
        break
      case "email":
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
        isValid = emailRegex.test(value)
        break
      case "password":
        const regPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
        isValid = regPassword.test(value)
        break
      case "repeatPassword":
        isValid = registerForm.password === value || value === ""
        break
      default:
        break;
    }
    if (re) isValid = re.exec(value) ? false : true;

    setRegisterForm({ ...registerForm, [name]: value })
    if (!isValid) return setInputError({ ...inputError, [name]: errorMessage[name] })
    if (isValid) return setInputError({ ...inputError, [name]: isValid ? [] : errorMessage[name]
      // publisher: [],
      // email: [],
      // password: [],
      // repeatPassword: [],
      // code: ""
    })

  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = {
      name: registerForm.publisher,
      email: registerForm.email,
      password: registerForm.password,
      role_code: 1
    }

    await API_POST_MAMBOO.actions.doSignUp(data)
      .then((res) => {
        return API_POST_MAMBOO.actions.doSignIn({ email: data.email, password: data.password }).then(async (response) => {
          setProfile(response.profile)
          // Wajib, sama seperti di Login.js: penjaga rute menentukan tujuan
          // dari `serverProfile`. Tanpa pengambilan ini profilnya tetap null,
          // penjaga tidak tahu anggota ini belum Member, dan dashboard
          // terlanjur terbuka sampai halaman di-reload.
          await fetchServerProfile()
          navigate('/')
        })
        // handleBackToLogin()
      })
      .catch((err) => {
        if(err.response.data.data.includes('Email')) {
          setInputError({...inputError, email: [err.response.data.data]})
        } else {
          setInputError({ password: [...err.response.data.data] })
        }
      })
  }

  return (

    <Container>
      <div className='text-wrapper'>
        <h3>Register</h3>
        <h6>LOKA Publishing pastikan karya cipta dikelola dengan baik. Bantu nilai ekonomi dari karya ciptamu dengan transparan.</h6>
      </div>
      <Col>
        <Form className='auth-form' onSubmit={handleSubmit}>
          <FormGroup className='custom-form-group'>
            <CustomInput
              label="Nama Songwriter"
              placeholder="Nama Songwriter"
              onChange={onChange}
              value={registerForm.publisher}
              type="text"
              name="publisher"
              errorArr={inputError.publisher}
            />
          </FormGroup>
          <FormGroup className='custom-form-group'>
            <CustomInput
              label="Email"
              name="email"
              placeholder="Email address"
              onChange={onChange}
              value={registerForm.email}
              Icon={Mail}
              iconPosition="left"
              errorArr={inputError.email}
            />
          </FormGroup>
          <FormGroup className='custom-form-group'>
            <CustomInput
              label="Password"
              name="password"
              placeholder="Password"
              onChange={onChange}
              value={registerForm.password}
              type={`${isPasswordShow.password ? "text" : "password"}`}
              Icon={isPasswordShow.password ? Eye : EyeOff}
              iconPosition="right"
              iconAction={() => passwordIconAction("password")}
              // error={inputError.password}
              errorArr={inputError.password}

            />
          </FormGroup>
          <FormGroup className='custom-form-group'>
            <CustomInput
              label="Ulangi Password"
              name="repeatPassword"
              placeholder="Password"
              onChange={onChange}
              value={registerForm.repeatPassword}
              type={`${isPasswordShow.repeatPassword ? "text" : "password"}`}
              Icon={isPasswordShow.repeatPassword ? Eye : EyeOff}
              iconPosition="right"
              iconAction={() => passwordIconAction("repeatPassword")}
              errorArr={inputError.repeatPassword}
            />
          </FormGroup>
          {/* <FormGroup className='custom-form-group'>
            <CustomInput
              label="Invitation Code"
              placeholder="Masukan Code"
              type="text"
              name="invitationCode"
              onChange={onChange}
              value={registerForm.code}
            />
          </FormGroup> */}
          <FormGroup
            check
            inline
          >
            <Input type="checkbox" />
            <Label check>
              Remember me
            </Label>
          </FormGroup>
          <CustomButton
            label="Registrasi"
            color={inputError.publisher.length === 0 && inputError.email.length === 0 && inputError.password.length === 0 && inputError.repeatPassword.length === 0 && registerForm.publisher !== "" && registerForm.email !== "" && registerForm.password !== "" && registerForm.repeatPassword !== "" ? "primary-btn" : "secondary-btn"}
            disabled={inputError.publisher.length === 0 && inputError.email.length === 0 && inputError.password.length === 0 && inputError.repeatPassword.length === 0 && registerForm.publisher !== "" && registerForm.email !== "" && registerForm.password !== "" && registerForm.repeatPassword !== "" ? false : true }
          />
        </Form>
      </Col>
      <div className='bottom-text'>
        <span>Sudah Punya Akun? </span>
        <span className='action-text' onClick={handleBackToLogin}>Login Sekarang</span>
      </div>
    </Container>
  )
}

export default Register